


export const rewindowSeriesToMonthly=(data)=>{
  // Sort the data array by date in ascending order
  data.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

  // Create an object to store the last object for each month
  const monthlyData = {};

  // Iterate over each object in the data array
  for (const obj of data) {
    const date = new Date(obj.timestamp);
    const yearMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

    // Update the last object for the corresponding month
    monthlyData[yearMonth] = obj;
  }

  // Convert the monthlyData object to an array
  const result = Object.values(monthlyData);

  return result;
}


export const filterSeriesBetweenRange = (data, startDate, endDate) => {
  // Filter the data array based on the timestamp range
  const filteredData = data.filter(obj => {
    const date = new Date(obj.timestamp);
    return date >= startDate && date <= endDate;
  });

  return filteredData;
};